import getIcon from 'get-icon';
import scaleNumbers from '../helpers/scaleNumbers.js';
import { createAnyElement } from "../helpers/createElement.js";
var lastScrollPosition = 0;
const header = document.querySelector("header");


import { startLiveReload } from '../helpers/livereload.js';

const toggleNavigation = (e) => {
    header.classList.toggle("open");
    document.documentElement.classList.toggle("nav");
    e.preventDefault();
    return false;
}

const login = () => {
    console.log("running login script");
 
    if (window.navigator.standalone || window.navigator.userAgent.indexOf('hangthedj')>-1) {
        document.body.classList.add("standalone");
    }

    document.querySelectorAll('body:not(.onboarding) .ctas button.icon, body:not(.onboarding) .ctas .button.icon').forEach((elm) => {
        elm.innerHTML += getIcon(elm.dataset.icon);
        elm.addEventListener("click",function(e) {
            document.querySelector("#provider").setAttribute("value",e.target.getAttribute("value"));
            document.querySelector("form").submit();
            e.preventDefault();
        })
    })
    document.querySelectorAll('body.onboarding .ctas .button.icon').forEach((elm) => {
        elm.innerHTML += getIcon(elm.dataset.icon);
    })
    document.querySelector("header a[href='#navigation']").addEventListener("click",toggleNavigation);
    document.querySelector(".icon-burger").innerHTML = getIcon('burger',false,1.4);
    document.querySelector(".icon-burger svg path").removeAttributeNS(null,"style");
    document.querySelector(".icon-download").innerHTML = getIcon('download',false,1.4);
    setTimeout(() => document.querySelector("header").classList.add("loaded"),200);
    
    addCssResizeScale();
    setTimeout(addCssResizeScale,1000);
    window.addEventListener("resize",addCssResizeScale);
   
    if (document.body.classList.contains("host")) return;
    if (account.passwordToggle) {
        var label = createAnyElement({ 
            type:'label',
            innerHTML:'Playlist password',
            attributes: { for: 'password' }
        })
        document.querySelector(".fields").appendChild(label);
    
        var password = createAnyElement({ 
            type:'input',
            attributes: { 
                type: 'password',
                name: 'password',
                id: 'password',
                placeholder:'Enter the playlist password'
            }
        })
        document.querySelector(".fields").appendChild(password);
        if (loginError) {
            password.classList.add("shake");
            var errorMessage = document.createElement("p");
            errorMessage.className="error";
            errorMessage.innerHTML = "The password wasn't accepted.";
            document.querySelector(".fields").appendChild(errorMessage);
        } 
    }
    
    var links = document.querySelectorAll('button');
    
    document.querySelectorAll('select.button').forEach((elm) => {
        elm.addEventListener('change',(e) => {
            console.log("target",e.target.value);
            document.querySelector("#provider").setAttribute("value",e.target.value);
            e.target.value="";
            document.querySelector("form").submit();
        })
    })
    
}
const headerScrollHandler = (e) => {
    
    const scrollTop = document.body.scrollTop || document.documentElement.scrollTop;
    var scrollDirectionDown = true;

    if (scrollTop!=lastScrollPosition) {
        scrollDirectionDown = (scrollTop>lastScrollPosition);
    }

    var headerTriggerPoint = scrollDirectionDown? header.scrollHeight : 0;
    if (scrollTop>headerTriggerPoint) {
        
        if (header.classList.contains("offscreen")) {
            if (scrollDirectionDown) {
                header.classList.add("inactive");
                header.classList.remove("active");
            } else {
                header.classList.remove("inactive");
                header.classList.add("active");
            }
        }
        header.classList.add("offscreen");
    } else {
        header.classList.remove("offscreen")
        header.classList.remove("inactive");
        header.classList.remove("active");
    }

    lastScrollPosition = scrollTop;
}
const headerController = () => {
    window.addEventListener("scroll",headerScrollHandler);
    window.addEventListener("resize",headerScrollHandler);
}
const addCssResizeScale = () => {
    const incoming = document.querySelector("section#hero").getBoundingClientRect().height / 1440;
	var scale;
    if (document.body.classList.contains("onboarding")) {
        scale = scaleNumbers(incoming,0.5,0.8,0.9,1.4);
        console.log("onboarding scale");
    } else {
       scale =  scaleNumbers(incoming,0.5,0.8,0.9,1.5);
    }
	document.documentElement.style.setProperty('--scale_factor', scale);
}
headerController();
login();

startLiveReload();